<template>
  <div class="theme-switcher">
    <i class="pi pi-sun"></i>
    <ToggleSwitch
        v-model="appState.isDarkTheme"
        @change="appState.toggleTheme"
        :trueValue="true"
        :falseValue="false"
    />
    <i class="pi pi-moon"></i>
  </div>
</template>
<script setup>
import ToggleSwitch from 'primevue/toggleswitch'
import { useAppStateStore } from '@/modules/chat/stores/appStore';

const appState = useAppStateStore();
</script>